import api from '../api/client';
// components/MonthlyTrend.js
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import config from '../config';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MonthlyTrend = ({ dateRange, datas }) => {
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(true);
    const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
    const apiUrl = config[environment].apiUrl;
// Fetch monthly trend data from the backend
    const fetchMonthlyTrendData = async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            if (dateRange.startDate && dateRange.endDate) {
                params.append('start', dateRange.startDate);
                params.append('end', dateRange.endDate);
            } else {
                params.append('period', dateRange?.period);
            }

            const response = await api.get(`/api/trend?${params}`);
            const data = await response.json();

            // Format the data for the chart
            const formattedData = {
                labels: data.labels || [],
                datasets: [
                    {
                        label: 'Income',
                        data: data.income || [],
                        borderColor: 'rgb(75, 192, 192)',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        tension: 0.3,
                        fill: true
                    },
                    {
                        label: 'Expenses',
                        data: data.expenses || [],
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        tension: 0.3,
                        fill: true
                    }
                ]
            };

            setChartData(formattedData);
        } catch (error) {
            console.error('Error fetching monthly trend data:', error);
            // Fallback to empty data if API fails
            setChartData({
                labels: [],
                datasets: [
                    {
                        label: 'Income',
                        data: [],
                        borderColor: 'rgb(75, 192, 192)',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        tension: 0.3,
                        fill: true
                    },
                    {
                        label: 'Expenses',
                        data: [],
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        tension: 0.3,
                        fill: true
                    }
                ]
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMonthlyTrendData();
    }, [dateRange]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: 'Monthly Income vs Expenses'
            }
        }
    };

    if (loading) {
        return (
            <div className="bg-white p-5 rounded-lg shadow">
                <div className="text-center py-4">Loading trend data...</div>
            </div>
        );
    }

    return (
        <div className="" >
            <Line data={chartData} options={options}/>
        </div>
    );
};

export default MonthlyTrend;
